module.exports = __webpack_public_path__ + "static/media/logo.39b1a25b.svg";